
import { Card } from "@arco-design/web-react";

export const BOMs = () => {

    return (
        <Card>BOMs</Card>
    );
}
